import { CreateAbstractSerializer } from '@ftr/serialization';
import { ChargeMetadata } from './ChargeMetadata';
import { PerMinuteFeeChargeMetadata } from './PerMinuteFeeChargeMetadata';
export const chargeMetadataSerializer = CreateAbstractSerializer(ChargeMetadata, [
    { discriminator: 'PerMinuteFeeChargeMetadata', constructor: PerMinuteFeeChargeMetadata },
]);
